import { createStaticReducer } from '../../../../packages/redux-utils';

const defaultState = '';

export const duplicateOfferLinkReducer = createStaticReducer<string>(defaultState);
